import { Button, IconButton, Typography } from "@suraasa/placebo-ui"
import { Xmark } from "iconoir-react"
import React, { useState } from "react"

interface ResumeTourBoxProps {
  title: string
  subTitle: string
  onClose?: () => void
  onContinue?: () => void
}

const ResumeTourBox: React.FC<ResumeTourBoxProps> = ({
  title,
  subTitle,
  onClose,
  onContinue,
}) => {
  const [isVisible, setIsVisible] = useState(true)

  const handleClose = () => {
    setIsVisible(false)
    onClose?.()
  }

  const handleContinue = () => {
    setIsVisible(false)
    onContinue?.()
  }

  if (!isVisible) return null

  return (
    <div className="fixed bottom-7 right-3 z-10 rounded-2xl bg-[#0E1525] sm:bottom-3 sm:max-w-[400px]">
      <div className="flex flex-col p-2.5">
        <div className="flex items-start justify-between gap-1">
          <Typography
            variant="title4"
            className="max-w-[250px] leading-5 text-surface"
          >
            {title}
          </Typography>
          <IconButton
            onClick={handleClose}
            className="!size-2.5 text-surface hover:bg-onSurface-700 focus:!bg-onSurface-800"
          >
            <Xmark className="!size-2" />
          </IconButton>
        </div>
        <Typography
          variant="smallBody"
          className="mt-1 max-w-[300px] text-onSurface-400"
        >
          {subTitle}
        </Typography>
        <div className="mt-2 flex items-center justify-end gap-1.5">
          <Button
            color={null}
            onClick={handleClose}
            className="rounded-[10px] bg-[#1B2334] text-surface"
            size="sm"
          >
            <Typography variant="strongSmallBody">Maybe Later</Typography>
          </Button>
          <Button
            color={null}
            className="rounded-[10px] bg-surface-50 text-onSurface-900"
            size="sm"
            onClick={handleContinue}
          >
            <Typography variant="strongSmallBody">Let&apos;s Go</Typography>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default ResumeTourBox
